import { createApi, endpoint } from '@/shared/lib/http/endpoint';

// /notification/unread-list — backend aggregates two buckets into one
// response: `barNotifyList` (top flashbar) + `notifyList` (sidebar bell
// popover). The aggregator wrapper is NOT in cloud-typings (this endpoint
// is hand-rolled on the backend side, not proto-generated), so the wrapper
// shape is declared here. Each bucket reuses the proto-generated
// ListNotifyMsgRsp — `{ total?: number; notify_msgs?: NotifyMsg[] }`.
export type UnreadListResponse = {
  barNotifyList?: Api.Notification.ListNotifyMsgRsp;
  notifyList?: Api.Notification.ListNotifyMsgRsp;
};

export const notificationApi = createApi({
  '/notification/unread-list': endpoint<Api.Notification.ListNotifyMsgReq, UnreadListResponse>(
    'POST',
  ),
  '/notification/list': endpoint<
    Api.Notification.ListNotifyMsgReq,
    Api.Notification.ListNotifyMsgRsp
  >('POST'),
  '/notification/toggle-read-state': endpoint<Api.Notification.ToggleNotifyMsgStateReq, void>(
    'POST',
  ),
  '/notification/mark-all-read': endpoint<Api.Notification.ChangeAllNotifyMsgStateReq, void>(
    'POST',
  ),
});
